import { useEffect } from "react";
import { t } from "i18next";
import { Button, Card } from "react-bootstrap";
import GoBack from "@main/panel-components/GoBack";
import useConfigurationAction from "../actions/configuration/useConfigurationAction";

function ProducerConfigurationTab(props: { producerId: string, formDefaultValues: any}) {
  const { producerId, formDefaultValues } = props;

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate
  } = useConfigurationAction(parseInt(producerId), formDefaultValues);

  useEffect(() => {
    if (!producerId ) return;
    getFunction(producerId);
  }, [producerId]);

  if (!producerId) return null;

  return (
    <Card>
      <Card.Header>
        <Card.Title><GoBack/> {t("configuration_data")}</Card.Title>
      </Card.Header>

      <Card.Body>
        {actionTemplate}
      </Card.Body>

      <Card.Footer>
        <Button variant="primary" onClick={onSubmitFunction}>
          {t('save_changes')}
        </Button>
      </Card.Footer>
    </Card>
  );
}

export default ProducerConfigurationTab;
